import React from "react"

type UlendoWordmarkProps = {
  className?: string
  iconOnly?: boolean
  size?: number
}

const LOGO_SRC = "/ulendo-logo.png"

export default function UlendoWordmark({ className, iconOnly = false, size = 40 }: UlendoWordmarkProps) {
  const imageClass = iconOnly ? `block ${className ?? ""}`.trim() : "block"
  const containerClass = iconOnly ? undefined : `inline-flex items-center ${className ?? ""}`.trim()
  const image = (
    <img
      src={LOGO_SRC}
      alt="Ulendo wordmark"
      className={imageClass}
      style={{ height: size, width: "auto" }}
    />
  )

  if (iconOnly) return image

  return <span className={containerClass}>{image}</span>
}
